import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsDots = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <circle cx="12" cy="2.8898354" r="1.9023283" />
        <circle cx="12" cy="12.1743326" r="1.9023283" />
        <circle cx="12" cy="21.4588299" r="1.9023283" />
      </g>
    </SvgIcon>
  );
});

export default AppIconsDots;
